'use strict';

import React from 'react';

import moment from "moment-timezone";

import Day from './Day/Day';


const Week = ({ element, week, date, initialDate, disabledDates, timezoneName, setDate, setAvailability }) => {
  const weekStart = plus => {
    return (
      moment(week)
        .startOf('week')
        .add(plus ? plus : 0, 'days')
        .format('YYYY-MM-DD')
    )
  };

  const weekArr = [weekStart(), weekStart(1), weekStart(2), weekStart(3), weekStart(4), weekStart(5), weekStart(6)];

  return (
    <div className="Week">
      {weekArr.map((d, i) => 
        <Day 
          key={i}
          element={element}
          date={date}
          week={moment(week).startOf('week').add(i, 'day')} 
          disabled={disabledDates.includes(weekStart(i))}
          timezoneName={timezoneName}
          setDate={setDate}
          setAvailability={setAvailability}
        />
      )}
    </div>
  ) 
} 

export default Week
